var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-3" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", { attrs: { for: "" } }, [
                  _vm._v("Период продаж за период:"),
                ]),
                _vm._v(" "),
                _c("date-range-picker", {
                  ref: "picker",
                  attrs: {
                    startDate: _vm.startDate,
                    opens: "right",
                    ranges: _vm.ranges,
                    "locale-data": _vm.date_locale,
                  },
                  model: {
                    value: _vm.dateRange,
                    callback: function ($$v) {
                      _vm.dateRange = $$v
                    },
                    expression: "dateRange",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "ul",
            { staticClass: "nav nav-tabs", attrs: { role: "tablist" } },
            [
              _c(
                "li",
                { staticClass: "nav-item", attrs: { role: "presentation" } },
                [
                  _c(
                    "button",
                    {
                      staticClass: "nav-link active",
                      attrs: {
                        id: "store-tab",
                        "data-toggle": "tab",
                        "data-target": "#store_tab",
                        type: "button",
                        role: "tab",
                        "aria-controls": "store_tab",
                        "aria-selected": "true",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setActiveTab("byPriority")
                        },
                      },
                    },
                    [_vm._v("Статистика по складу\n            ")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item", attrs: { role: "presentation" } },
                [
                  _c(
                    "button",
                    {
                      staticClass: "nav-link",
                      attrs: {
                        id: "country-tab",
                        "data-toggle": "tab",
                        "data-target": "#country_tab",
                        type: "button",
                        role: "tab",
                        "aria-controls": "country_tab",
                        "aria-selected": "false",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setActiveTab("byCountry")
                        },
                      },
                    },
                    [_vm._v("Статистика по стране закупки\n            ")]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tab-content", attrs: { id: "myTabContent" } },
            [
              _c(
                "div",
                {
                  staticClass: "tab-pane mt-1 fade show active",
                  attrs: {
                    id: "store_tab",
                    role: "tabpanel",
                    "aria-labelledby": "store-tab",
                  },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Проект:"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filterProject,
                                expression: "filterProject",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.filterProject = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function ($event) {
                                  return _vm.updateProject(_vm.filterProject)
                                },
                              ],
                            },
                          },
                          [
                            _c("option", { attrs: { value: "0" } }, [
                              _vm._v("Все проекты"),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.$AllProjects, function (project) {
                              return project.is_active
                                ? _c(
                                    "option",
                                    { domProps: { value: project.id } },
                                    [
                                      _vm._v(
                                        _vm._s(project.title) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e()
                            }),
                          ],
                          2
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Выбор приоритета:"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.priority,
                                expression: "priority",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.priority = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function ($event) {
                                  return _vm.showStatistics(1, true)
                                },
                              ],
                            },
                          },
                          [
                            _c("option", { attrs: { value: "0" } }, [
                              _vm._v("Все приоритеты"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "1" } }, [
                              _vm._v("Приоритет 1"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "2" } }, [
                              _vm._v("Приоритет 2"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "3" } }, [
                              _vm._v("Приоритет 3"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "4" } }, [
                              _vm._v("Приоритет 4"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "5" } }, [
                              _vm._v("Приоритет 5"),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Экспорт ссылок проекта:"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedProject,
                                expression: "selectedProject",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.selectedProject = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(_vm.$AllProjects, function (project) {
                            return project.is_active
                              ? _c(
                                  "option",
                                  { domProps: { value: project.id } },
                                  [
                                    _vm._v(
                                      _vm._s(project.title) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              : _vm._e()
                          }),
                          0
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("label", { attrs: { for: "check_1" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filter.hideDrugs,
                            expression: "filter.hideDrugs",
                          },
                        ],
                        staticClass: "from-control",
                        attrs: { type: "checkbox", id: "check_1" },
                        domProps: {
                          checked: Array.isArray(_vm.filter.hideDrugs)
                            ? _vm._i(_vm.filter.hideDrugs, null) > -1
                            : _vm.filter.hideDrugs,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.filter.hideDrugs,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.filter,
                                    "hideDrugs",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.filter,
                                    "hideDrugs",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.filter, "hideDrugs", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(
                        "\n                Не показывать препараты, которых меньше "
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filter.limitQty,
                            expression: "filter.limitQty",
                          },
                        ],
                        staticClass: "form-control inline",
                        attrs: { type: "number" },
                        domProps: { value: _vm.filter.limitQty },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.filter,
                              "limitQty",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" уп.\n              "),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filter.stores,
                            expression: "filter.stores",
                          },
                        ],
                        staticClass: "form-check-input ml-0",
                        attrs: {
                          type: "radio",
                          id: "inlineRadio2",
                          value: "-1",
                        },
                        domProps: { checked: _vm._q(_vm.filter.stores, "-1") },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.filter, "stores", "-1")
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-3",
                          attrs: { for: "inlineRadio2" },
                        },
                        [_vm._v("Не учитывать наличие на складах")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filter.stores,
                            expression: "filter.stores",
                          },
                        ],
                        staticClass: "form-check-input ml-0",
                        attrs: {
                          type: "radio",
                          id: "inlineRadio1",
                          value: "3",
                        },
                        domProps: { checked: _vm._q(_vm.filter.stores, "3") },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.filter, "stores", "3")
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-3",
                          attrs: { for: "inlineRadio1" },
                        },
                        [_vm._v("На складе МСК")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filter.stores,
                            expression: "filter.stores",
                          },
                        ],
                        staticClass: "form-check-input ml-0",
                        attrs: {
                          type: "radio",
                          id: "inlineRadio3",
                          value: "0",
                        },
                        domProps: { checked: _vm._q(_vm.filter.stores, "0") },
                        on: {
                          change: function ($event) {
                            return _vm.$set(_vm.filter, "stores", "0")
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-check-label ml-3",
                          attrs: { for: "inlineRadio3" },
                        },
                        [_vm._v("На всех складах")]
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-pane mt-1 fade",
                  attrs: {
                    id: "country_tab",
                    role: "tabpanel",
                    "aria-labelledby": "country-tab",
                  },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Основные страны закупок"),
                          ]),
                          _vm._v(" "),
                          _c("multiselect", {
                            attrs: {
                              options: _vm.$AllCountries,
                              multiple: true,
                              label: "name",
                              "track-by": "name",
                              placeholder: "Выберите страны",
                              "select-label": "Выбрать",
                              "deselect-label": "Убрать страну",
                            },
                            model: {
                              value: _vm.filter.selectedCountries,
                              callback: function ($$v) {
                                _vm.$set(_vm.filter, "selectedCountries", $$v)
                              },
                              expression: "filter.selectedCountries",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Пресеты"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex flex_gap_5" },
                          [
                            _vm._l(_vm.selectedCountriesPreset, function (s) {
                              return _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setCountries(s)
                                    },
                                  },
                                },
                                _vm._l(s, function (c, i) {
                                  return _c("span", [
                                    _vm._v(
                                      _vm._s(i !== 0 ? ", " : "") +
                                        _vm._s(_vm.allCountries[c]?.title)
                                    ),
                                  ])
                                }),
                                0
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    _vm.filter.selectedCountries = []
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "Сбросить\n                      выбор\n                    "
                                ),
                              ]
                            ),
                          ],
                          2
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-right" },
          [
            (_vm.records[_vm.filter.requestType] ?? []).length
              ? _c("LoadingButton", {
                  attrs: {
                    title: "Экспорт в XLSX",
                    className: "btn btn-outline-success",
                    loading: _vm.loading,
                    color: _vm.$constants.SUCCESS_COLOR,
                    onClick: () => _vm.showStatistics(1, false, true),
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("LoadingButton", {
              attrs: {
                title: "Показать",
                className: "btn btn-outline-info",
                loading: _vm.loading,
                color: _vm.$constants.LOADING_COLOR,
                onClick: () => _vm.showStatistics(1, true),
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    (_vm.records[_vm.filter.requestType] ?? []).length || _vm.loading
      ? _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("pulse-loader", {
                staticClass: "text-center",
                attrs: {
                  loading: _vm.loading,
                  color: _vm.$constants.LOADING_COLOR,
                },
              }),
              _vm._v(" "),
              !_vm.loading
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        { staticClass: "flex justify-content-between" },
                        [
                          _c("div", [
                            _vm.paginator
                              ? _c("span", [
                                  _vm._v("Всего препаратов: "),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.paginator.total)),
                                  ]),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-right" },
                            [
                              _vm.paginator
                                ? _c("paginate", {
                                    attrs: {
                                      "page-count": _vm.paginator.last_page,
                                      "page-range": 11,
                                      "margin-pages": 2,
                                      "click-handler": _vm.showStatistics,
                                      "prev-text": "&laquo",
                                      "next-text": "&raquo",
                                      "container-class": "pagination",
                                      "prev-class": "page-item",
                                      "prev-link-class": "page-link",
                                      "page-class": "page-item",
                                      "page-link-class": "page-link",
                                      "next-class": "page-item",
                                      "next-link-class": "page-link",
                                      "active-class": "active green_btn",
                                    },
                                    model: {
                                      value: _vm.paginator.current_page,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.paginator,
                                          "current_page",
                                          $$v
                                        )
                                      },
                                      expression: "paginator.current_page",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.filter.requestType === "byPriority"
                        ? [
                            _c(
                              "table",
                              { staticClass: "table table-sm table-hover" },
                              [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", { attrs: { width: "100px" } }, [
                                      _vm._v("ID"),
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { attrs: { width: "100px" } }, [
                                      _vm._v("Приоритет"),
                                    ]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("Препарат")]),
                                    _vm._v(" "),
                                    _c("th", { staticClass: "fix_width" }, [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            active: _vm.activeSort.sold,
                                            sortable: true,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateSort("sold")
                                            },
                                          },
                                        },
                                        [
                                          _vm.activeSort.field === "sold"
                                            ? _c("i", {
                                                class: {
                                                  "icon-fa icon-fa-sort-amount-desc":
                                                    _vm.activeSort.desc,
                                                  "icon-fa icon-fa-sort-amount-asc":
                                                    !_vm.activeSort.desc,
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v("\n                Продано"),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { staticClass: "fix_width" }, [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            active: _vm.activeSort.price,
                                            sortable: true,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateSort("price")
                                            },
                                          },
                                        },
                                        [
                                          _vm.activeSort.field === "price"
                                            ? _c("i", {
                                                class: {
                                                  "icon-fa icon-fa-sort-amount-desc":
                                                    _vm.activeSort.desc,
                                                  "icon-fa icon-fa-sort-amount-asc":
                                                    !_vm.activeSort.desc,
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v("\n                Сумма"),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { staticClass: "fix_width" }, [
                                      _vm._v("Средняя цена\n              "),
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { staticClass: "fix_width" }, [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            active: _vm.activeSort.sold,
                                            sortable: true,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateSort("mainStore")
                                            },
                                          },
                                        },
                                        [
                                          _vm.activeSort.field === "mainStore"
                                            ? _c("i", {
                                                class: {
                                                  "icon-fa icon-fa-sort-amount-desc":
                                                    _vm.activeSort.desc,
                                                  "icon-fa icon-fa-sort-amount-asc":
                                                    !_vm.activeSort.desc,
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(
                                            "\n                Наличие МСК"
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { staticClass: "fix_width" }, [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            active: _vm.activeSort.sold,
                                            sortable: true,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateSort("allStores")
                                            },
                                          },
                                        },
                                        [
                                          _vm.activeSort.field === "allStores"
                                            ? _c("i", {
                                                class: {
                                                  "icon-fa icon-fa-sort-amount-desc":
                                                    _vm.activeSort.desc,
                                                  "icon-fa icon-fa-sort-amount-asc":
                                                    !_vm.activeSort.desc,
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(
                                            "\n                Наличие Все"
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  [
                                    _vm.recordsLoading
                                      ? _c("tr", [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "10" } },
                                            [
                                              _c("pulse-loader", {
                                                staticClass: "text-center",
                                                attrs: {
                                                  loading: _vm.recordsLoading,
                                                  color:
                                                    _vm.$constants
                                                      .LOADING_COLOR,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.records[_vm.filter.requestType],
                                      function (record) {
                                        return !_vm.recordsLoading
                                          ? _c("tr", { key: record.id }, [
                                              _c("td", [
                                                _vm._v(_vm._s(record.id)),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c(
                                                  "select",
                                                  {
                                                    staticClass: "form-control",
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.updateDrug(
                                                          $event.target.value,
                                                          record.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "1" },
                                                        domProps: {
                                                          selected:
                                                            1 ==
                                                            record.priority,
                                                        },
                                                      },
                                                      [_vm._v("1")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "2" },
                                                        domProps: {
                                                          selected:
                                                            2 ==
                                                            record.priority,
                                                        },
                                                      },
                                                      [_vm._v("2")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "3" },
                                                        domProps: {
                                                          selected:
                                                            3 ==
                                                            record.priority,
                                                        },
                                                      },
                                                      [_vm._v("3")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "4" },
                                                        domProps: {
                                                          selected:
                                                            4 ==
                                                            record.priority,
                                                        },
                                                      },
                                                      [_vm._v("4")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "5" },
                                                        domProps: {
                                                          selected:
                                                            5 ==
                                                            record.priority,
                                                        },
                                                      },
                                                      [_vm._v("5")]
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(record.title)),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(record.totalQty)),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(record.totalPrice)
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    Math.round(
                                                      record.totalPrice /
                                                        record.totalQty
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    Math.round(
                                                      record.inMainStore * 10
                                                    ) / 10
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    Math.round(
                                                      record.inAllStores * 10
                                                    ) / 10
                                                  )
                                                ),
                                              ]),
                                            ])
                                          : _vm._e()
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.filter.requestType === "byCountry"
                        ? [
                            _c(
                              "div",
                              { staticClass: "mb-1" },
                              [
                                _c("p", [
                                  _vm._v("за "),
                                  _c("strong", [_vm._v(_vm._s(_vm.dayStats))]),
                                  _vm._v(" день(й), средние продажи в день"),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        Math.round(
                                          _vm.groupCountry.reduce(
                                            (acc, g) => acc + g.total_qty,
                                            0
                                          ) / _vm.dayStats
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" общие продажи в день"),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        Math.round(
                                          _vm.groupCountry
                                            .filter((g) =>
                                              _vm.filter.selectedCountries
                                                .length
                                                ? _vm.filter.selectedCountries
                                                    .map((c) => c.id)
                                                    .includes(
                                                      g.income_country_id
                                                    )
                                                : true
                                            )
                                            .reduce(
                                              (acc, g) => acc + g.total_qty,
                                              0
                                            ) / _vm.dayStats
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(
                                    ":\n              все выбранные страны"
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm
                                    .sortArray(
                                      _vm.groupCountry,
                                      "total_qty",
                                      "desc"
                                    )
                                    .filter((g) =>
                                      _vm.filter.selectedCountries
                                        .map((c) => c.id)
                                        .includes(g.income_country_id)
                                    ),
                                  function (g) {
                                    return _c("p", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            Math.round(
                                              g.total_qty / _vm.dayStats
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(
                                        ": " +
                                          _vm._s(
                                            _vm.allCountries[
                                              g.income_country_id
                                            ]?.name
                                          ) +
                                          "\n            "
                                      ),
                                    ])
                                  }
                                ),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("SaleDrugsTableByCountry", {
                              attrs: {
                                records: _vm.records[_vm.filter.requestType],
                                days: _vm.dayStats,
                                currentPage: _vm.paginator.current_page,
                              },
                            }),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-right" },
                        [
                          _vm.paginator
                            ? _c("paginate", {
                                attrs: {
                                  "page-count": _vm.paginator.last_page,
                                  "page-range": 11,
                                  "margin-pages": 2,
                                  "click-handler": _vm.showStatistics,
                                  "prev-text": "&laquo",
                                  "next-text": "&raquo",
                                  "container-class": "pagination",
                                  "prev-class": "page-item",
                                  "prev-link-class": "page-link",
                                  "page-class": "page-item",
                                  "page-link-class": "page-link",
                                  "next-class": "page-item",
                                  "next-link-class": "page-link",
                                  "active-class": "active green_btn",
                                },
                                model: {
                                  value: _vm.paginator.current_page,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.paginator, "current_page", $$v)
                                  },
                                  expression: "paginator.current_page",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }